import { SearchFilters } from '@telialt/core-search/src/model';

import { CategoryData, SeoFilters } from '../models';
import { getCategoryPathFromSubcategories } from './getCategoryPathFromSubcategories';

const splitPathnameToCategoryPathAndPathFilterValue = (path: string) => {
    const pathParts = path.split('/');
    const lastPart = pathParts.length > 2 ? pathParts.pop() : undefined; // `pathParts` is mutated
    const remainingPartsPath = pathParts.join('/');

    return {
        categoryPath: remainingPartsPath,
        pathFilterValue: lastPart,
    };
};

const findSeoFilterByPathValue = (
    seoFilters: SeoFilters,
    pathValue: string,
): { fieldName: string; fieldValue: string } => {
    for (const fieldName of Object.keys(seoFilters)) {
        for (const fieldValue of Object.keys(seoFilters[fieldName])) {
            if (seoFilters[fieldName][fieldValue] === pathValue) {
                return { fieldName, fieldValue };
            }
        }
    }

    return null;
};

export const readCategoryPathAndFilter = (
    pagePath: string,
    categoryData?: CategoryData,
): { categoryPath: string; pathFilter?: SearchFilters } => {
    const seoFilters = categoryData?.filters;
    const categoryPathFromSubcategories = getCategoryPathFromSubcategories(
        pagePath,
        categoryData?.parent?.subcategories,
    );

    if (!seoFilters || !Object.keys(seoFilters).length || pagePath === categoryPathFromSubcategories) {
        return { categoryPath: pagePath };
    }

    const { categoryPath, pathFilterValue } = splitPathnameToCategoryPathAndPathFilterValue(pagePath);
    const matchedField = findSeoFilterByPathValue(seoFilters, pathFilterValue);

    if (!matchedField) {
        return { categoryPath: pagePath };
    }

    const { fieldName, fieldValue } = matchedField;
    const pathFilter: SearchFilters = { [fieldName]: [fieldValue] };

    return { categoryPath, pathFilter };
};
